import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import {
  trackURL,
} from "../../../Library/URLs";
import {
  generateTransactionID,
  UserProfileData,
} from "../../../Library/Utilities";
import "../../../Assets/Style/CreateLocalShipment.scss";

const TrackForm = ({ shipmentNumber, setShipmentNumber, setTrackResults }) => {

  const form = useRef(null);
  const {
    reset,
  } = useForm();
  const [isClear, setIsClear] = useState(false);
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  useEffect(() => {
    if (!isClear) {
      return;
    } else {
      reset();
    }
  }, [isClear, reset]);

  const trackShipment = (e) => {
    e.preventDefault();

    const formValues = {};

    formValues["shipment_number"] = shipmentNumber;

    formValues["transaction_id"] = generateTransactionID(15);

    const newData = { ...formValues, ...UserProfileData() };

    setIsPending(true);

    console.log(newData);

    axios
      .post(trackURL, newData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsPending(false);
        if (response["data"]["success"] === true) {
          setTrackResults(response["data"]["data"]);
        } else {
          toast.error(response["data"]["message"]);
        }
      });
  };

  return (
    <form
      data-aos="fade-zoom-in"
      ref={form}
      onSubmit={trackShipment}
    >
      <div className="Box">
        <label htmlFor="street">SHIPPING CODE</label>
        <input
          id="street"
          placeholder="Enter shipping code"
          onChange={(e) => {
            setShipmentNumber(e.target.value);
            setTrackResults();
          }}
          value={shipmentNumber}
        />
        
      </div>
      <button className="btn">
        {isPending === false ? (
          <span className="button-text">
            {isPending ? "CONTINUE" : "TRACK SHIPMENT"}{" "}
          </span>
        ) : (
          <span className="spinner-border spinner-grow-sm" />
        )}
      </button>
    </form>
  );
};

export default TrackForm;
